import React, { useState, useMemo } from "react";
import queries from "../helpers/queries";
import { useQuery } from "@apollo/react-hooks";
import usePagination from "../Hooks/usePagination";
import { useForm, Controller } from "react-hook-form";
import { withRouter } from "react-router-dom";
import { FaBath, FaBed, FaRegBuilding, FaStreetView } from "react-icons/fa";
import Select from "react-select";
import _ from "lodash";

const Projects = withRouter(({ history }) => {
    const { handleSubmit, errors, control, reset } = useForm({
        defaultValues: {
            state: null,
            area: null,
        },
    });

    const filterSelectStyles = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                backgroundColor: "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
                "&:hover": {
                    borderColor: errors.area ? "#fc8181" : "#e2e8f0",
                },
            }),

            placeholder: (provided, state) => ({
                ...provided,
                color: "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),

            container: (provided, state) => ({
                ...provided,
                color: "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),
        }),
        [errors]
    );

    const updateFilters = (values) => {
        setFilters((prev) => ({
            ...prev,
            ...values,
            area: values.area ? values.area.value : "",
            state: values.state ? values.state.value : "",
        }));
        setPaginationState((prev) => ({ ...prev, page: 1 }));
    };

    const [projects, setProjects] = useState(false);
    const [areas, setAreas] = useState([]);
    const [states, setStates] = useState([]);

    const [paginationState, setPaginationState] = useState({
        limit: 9999,
        page: 1,
    });

    const [filters, setFilters] = useState({
        area: null,
        state: null,
        type: { value: "ongoing", label: "On-going" },
    });

    const { pagination } = usePagination({
        numberOfButtons: 2,
        currentPage: paginationState ? paginationState.page : 0,
        totalPages: paginationState ? paginationState.totalPages : 0,
    });

    useQuery(queries.FETCH_PROJECTS, {
        variables: {
            limit: paginationState.limit,
            page: paginationState.page,
            area: filters.area ? filters.area : "",
            state: filters.state ? filters.state : "",
            project: filters.project ? filters.project.value : "",
            type: filters.type ? filters.type.value : undefined,
        },
        fetchPolicy: "network-only",
        onCompleted: ({
            fetchProjectsAgent: { pagination, ...fetchProjectsAgent },
        }) => {
            setPaginationState(pagination);
            setProjects(fetchProjectsAgent.data);
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    useQuery(queries.FETCH_ALL_AREAS, {
        fetchPolicy: "network-only",
        onCompleted: ({ fetchAllAreas: _id, name }) => {
            setAreas(_id, name);
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    useQuery(queries.FETCH_ALL_STATES, {
        fetchPolicy: "network-only",
        onCompleted: ({ fetchStates: _id, name }) => {
            setStates(_id, name);
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const { data: projectsAllData } = useQuery(queries.FETCH_PROJECTS, {
        fetchPolicy: "network-only",
        variables: {
            limit: 9999,
            page: 1,
            state: "all",
        },
        // onCompleted: ({ fetchProjects: { data } }) => setProjects(data),
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    return (
        <div className="lg:flex">
            <div className="flex flex-wrap rounded-2xl w-full overflow-hidden p-8 lg:px-0 px-3">
                <div className="w-full project-card">
                    <div className="project-card-content">
                        <div className="project-filters flex flex-col lg:flex-row gap-4 lg:gap-0">
                            <div className="w-full lg:w-64 lg:mr-2">
                                <Select
                                    styles={filterSelectStyles}
                                    placeholder="Project"
                                    isSearchable={true}
                                    options={
                                        projectsAllData
                                            ? projectsAllData.fetchProjectsAgent.data.map(
                                                  (project) => ({
                                                      label: project.name,
                                                      value: project._id,
                                                  })
                                              )
                                            : []
                                    }
                                    value={filters.project}
                                    onChange={(val) =>
                                        setFilters((prev) => ({
                                            ...prev,
                                            project: val,
                                        }))
                                    }
                                />
                            </div>
                            <div className="w-full lg:w-64  lg:mr-2">
                                <Controller
                                    as={
                                        <Select
                                            styles={filterSelectStyles}
                                            isSearchable={true}
                                        />
                                    }
                                    name="area"
                                    placeholder="Area"
                                    control={control}
                                    options={areas.map((area) => ({
                                        label: area.name,
                                        value: area._id,
                                    }))}
                                    value={filters.area}
                                />
                            </div>
                            <div className="w-full lg:w-64 lg:mr-2">
                                <Controller
                                    as={
                                        <Select
                                            styles={filterSelectStyles}
                                            isSearchable={true}
                                        />
                                    }
                                    placeholder="State"
                                    name="state"
                                    control={control}
                                    options={states.map((state) => ({
                                        label: state.name,
                                        value: state._id,
                                    }))}
                                    value={filters.state}
                                />
                            </div>
                            <div className="w-full lg:w-64 lg:mr-2">
                                <Controller
                                    as={
                                        <Select
                                            styles={filterSelectStyles}
                                            isSearchable={false}
                                        />
                                    }
                                    name="type"
                                    control={control}
                                    rules={{ required: true }}
                                    options={[
                                        {
                                            label: "On-going",
                                            value: "ongoing",
                                        },
                                        {
                                            label: "Adhoc",
                                            value: "adhoc",
                                        },
                                    ]}
                                    defaultValue={{
                                        label: "On-going    ",
                                        value: "ongoing",
                                    }}
                                />
                            </div>
                            <button
                                className="project-search-button w-full lg:w-auto"
                                style={{ backgroundColor: "#d1a866" }}
                                onClick={handleSubmit(updateFilters)}
                            >
                                Search
                            </button>
                        </div>

                        <div className="project-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
                            {projects
                                ? projects.map((item, i) => (
                                      <div key={i} className="project-item w-full">
                                          <img
                                              className="project-item-image"
                                              src={item.image}
                                              alt={item.name}
                                          />
                                          <div className="project-item-content">
                                              <h3 className="project-item-title">
                                                  {item.name}
                                              </h3>
                                              <div
                                                  className="project-details-btn"
                                                  onClick={() =>
                                                      history.push(
                                                          `/projects/${item._id}`
                                                      )
                                                  }
                                              >
                                                  Project Details
                                              </div>
                                          </div>
                                      </div>
                                  ))
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Projects;
